import React from 'react';
import styled from 'styled-components';
import { Label } from 'semantic-ui-react';
import { theme } from '../../../styles/theme';

export const Container = styled.div`
  background: transparent;
  border-radius: 8px;
  flex: 1 0 calc(50% - 4px);
  min-width: 380px;
  width: 0;
  outline: none !important;
  position: relative;
  &:before {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-color: ${theme.colors.mainBlue};
    border-radius: 2.5px;
    width: 0;
    height: 0;
    min-height: 0;
    transition:
      height 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms,
      min-height 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms;
    z-index: 0;
    will-change: height, min-height;
  }

  > div {
    &:before {
      content: '';
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      background-color: ${theme.colors.mainBlue};
      border-radius: 2.5px;
      width: 0;
      height: 0;
      min-height: 0;
      transition:
        height 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms,
        min-height 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms;
      z-index: 0;
      will-change: height, min-height;
    }
  }

  &.highlight {
    &:before {
      width: 2px;
      min-height: 60px;
      height: 55%;
      left: -8px;
    }
    &.disabled {
      &:before {
        background-color: #ff625a;
      }
      &:after {
        content: '\f00d';
        position: absolute;
        color: #ff625a;
        top: 50%;
        transform: translateY(-50%);
        left: -13px;
        display: block;
        opacity: 1;
        width: 12px;
        height: 12px;
        font-family: Icons;
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 1.2;
        text-decoration: inherit;
        text-align: center;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        background: #f2f5fc;
        z-index: 1;
      }
    }
  }
  &.last-highlight {
    > div {
      &:before {
        width: 2px;
        min-height: 60px;
        height: 55%;
        right: -8px;
      }
    }
    &.disabled {
      > div {
        &:before {
          background-color: #ff625a;
        }
        &:after {
          content: '\f00d';
          position: absolute;
          color: #ff625a;
          top: 50%;
          transform: translateY(-50%);
          right: -13px;
          display: block;
          opacity: 1;
          width: 12px;
          height: 12px;
          font-family: Icons;
          font-style: normal;
          font-weight: 400;
          font-size: 12px;
          line-height: 1.2;
          text-decoration: inherit;
          text-align: center;
          -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
          background: #f2f5fc;
          z-index: 1;
        }
      }
    }
  }
`;

export const Row = styled(
  ({
    isDragging,
    isDraggingOver,
    shouldShowPlaceholder,
    shouldCollapse,
    innerRef,
    ...props
  }) => <div {...props} ref={innerRef} />,
)`
  min-height: ${({ isDragging, shouldCollapse }) =>
    isDragging && !shouldCollapse && '16px'};
  display: flex;
  justify-content: flex-start;
  margin-bottom: ${({ isDragging }) => (!isDragging ? '10px' : '0')};
  &:first-child {
    padding-top: ${({ isDragging }) => (!isDragging ? '10px' : '0')} !important;
  }
  border-radius: 8px;
  padding: 0 4px;
  position: relative;
  > * {
    margin: 0 8px;
  }
  > [data-rbd-draggable-id] {
    &:first-child {
      margin-left: -4px;
    }
    &:nth-last-child(2) {
      margin-right: -4px;
    }
  }
  &:before {
    content: '';
    position: absolute;
    width: 0;
    left: 50%;
    top: 7px;
    background: ${theme.colors.mainBlue};
    height: 0;
    transition:
      width 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms,
      height 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms;
    transform: translateX(-50%);
  }
  ${({ shouldShowPlaceholder }) =>
    shouldShowPlaceholder &&
    `
    &:before {
      width: 200px;
      height: 2px;
    }
  `}
`;

export const StyledLabel = styled(Label)`
  &&&& {
    box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.1);
    background-color: ${theme.colors.mainBlue};
    font: inherit;
    font-size: 16px;
    font-weight: 500;
    padding: 12px;
    color: #ffffff;
  }
`;
